import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppURL } from 'src/app/app.url';
import { AppService } from 'src/app/services/app.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-public-version',
  templateUrl: './public-version.component.html',
  styleUrls: ['./public-version.component.scss']
})
export class PublicVersionComponent {
  actionView: boolean = false;
  ogid: any
  constructor(private http: HttpClient,
    private ac: ActivatedRoute,
    private app: AppService,

  ) {
    this.app.viewPage = false;
    this.ogid = this.ac.snapshot.params['ogid']
    console.log(this.ogid);

    if (this.ogid) this.getVersion()
  }

  verItems: any = []
  contentURL: any = environment.content;

  getVersion() {
    this.http.get(`/api/version/list/${this.ogid}`).subscribe({
      next: (res: any) => {
        this.verItems = res


        this.verItems.Items.forEach((f: any) => {
          f.download = `${this.contentURL}${this.ogid}/${f.path}`
        });
        console.log(this.verItems);
      }
    })
  }

  deleteVersion(item: any) {
    console.log(item);
    this.http.post(`/api/version/delete/${this.ogid}/${item.id}`, item).subscribe({
      next: (res: any) => {
        this.getVersion();
      }
    })
  }

  download(item: any) {
    window.location.replace(item.download)
  }



  update(e: any) {
    if (e) {
      this.getVersion();
      this.close();
    }
  }

  close() {
    this.actionView = false
  }
}
